"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrowthRateInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const mui_inputs_mask_1 = require("@dzambalaorg/mui-inputs-mask");
const types_1 = require("@framework/types");
const GrowthRateInput = props => {
    const { name = "growthRate" } = props;
    const discreteStrategy = (0, react_hook_form_1.useWatch)({ name: "discreteStrategy" });
    if (discreteStrategy === types_1.DiscreteStrategy.EXPONENTIAL) {
        return (0, jsx_runtime_1.jsx)(mui_inputs_mask_1.CurrencyInput, { name: name, symbol: "", precision: 2 });
    }
    return null;
};
exports.GrowthRateInput = GrowthRateInput;
//# sourceMappingURL=index.js.map